const groupProducts = mpg.group.products.filter(p => p?.id);

const selectElement = document.querySelector('#print');

if(groupProducts.length > 0) {   

// Get current product handle from URL
const urlPath = window.location.pathname;
const currentHandle = urlPath.split('/products/')[1];

groupProducts.forEach(product => {
  const option = document.createElement('option');
  option.value = product.handle;
  const productTitle = product.title.split('|')[1].trim();
  option.textContent = productTitle;

  // Set as selected if handle matches
  if (product.handle === currentHandle) {
    option.selected = true;
  }

  selectElement.appendChild(option);
});

selectElement.addEventListener("change", () => {
  const selectedProduct = selectElement.value;
  window.location.href = `${window.Shopify.routes.root}products/${selectedProduct}`;
});

} else {

document.querySelector('.mobile--print-option').style.display = "none";

}
